export enum ConformityListContext {
  ReadyToSign = 1,
  ReadyToSend,
  SentToDOT
}
